import { defineStore } from 'pinia'
import { ref } from 'vue'
import _ from 'lodash'
import objectHandler from '@/utils/objectHandler';

export function createReadingConditionStore(readingId) {
  return defineStore(`rcs-${readingId}`, () => {
    const groups = ref({})
    const screens = ref({})
    const questions = ref({})

    function massUpsert(type,objectsToInsert) {
      if (!objectsToInsert?.size > 0) {
        return
      }
      switch (type) {
        case 'groups':
          let groupsClone = objectHandler.recursiveDeepCopy(groups.value)
          _.merge(groupsClone, objectHandler.mapToObject(objectsToInsert))
          groups.value = groupsClone
          break
        case 'screens':
          let screensClone = objectHandler.recursiveDeepCopy(screens.value)
          _.merge(screensClone, objectHandler.mapToObject(objectsToInsert))
          screens.value = screensClone
          break
        case 'questions':
          let questionsClone = objectHandler.recursiveDeepCopy(questions.value)
          _.merge(questionsClone, objectHandler.mapToObject(objectsToInsert))
          questions.value = questionsClone
          break
      }
    }

    function initReading() {
      groups.value = {}
      screens.value = {}
      questions.value = {}
    }

    function conditionsExistForReading() {
      return Object.keys(questions.value ?? [])?.length > 0
    }

    return {
      groups,
      screens,
      questions,
      initReading,
      massUpsert,
      conditionsExistForReading
    }
  },
    {
      persistedState: {
        storage: localStorage,
        serialize: (value) => JSON.stringify(value),
        deserialize: (value) => JSON.parse(value),
        overwrite: true
      }
    })()
}